import '.a0{padding:16px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.ca{gap:0px;}.ssr-plugin'
import '.m{flex:1;}.ssr-plugin'
import '.et{min-width:240px;}.ssr-plugin'
import '.a9{cursor:pointer;}.ssr-plugin'
import '.ea{width:32px;}.ssr-plugin'
import '.g8{height:32px;}.ssr-plugin'
import '.d9{margin-bottom:16px;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import React from 'react'
import { styled, type Style } from 'inlines'
import { radius } from '../../utils/radius.js'
import { colors } from '../../tokens/colors.js'
import { Text } from '../Text/index.js'
import { Icon, IconProps } from '../Icon/index.js'

type LinkCardProps = {
  title: string
  description: string
  icon?: IconProps['variant']
  style?: Style
  onClick?: () => void
}
export const LinkCard = ({
  title,
  description,
  icon,
  onClick,
  style,
}: LinkCardProps) => {
  return (
    <styled.div className="a0 a i ca m et a9"
      style={{
        borderRadius: radius[20],
        border: `1px solid ${colors.neutral20Adjusted}`,
        '&:hover': {
          backgroundColor: colors.neutral10Adjusted,
        },
        ...style,
      }}
      onClick={onClick}
    >
      <div className="ea g8 d9 a c d a9"
        style={{
          borderRadius: radius[8],
          border: `1px solid ${colors.neutral20Adjusted}`,
          background: `linear-gradient(180deg, transparent 0%, ${colors.neutral5} 100%)`,
        }}
      >
        <Icon variant={icon} color="neutral60" />
      </div>
      <Text variant="display-medium">{title}</Text>
      <Text variant="display-regular" color="neutral60">
        {description}
      </Text>
    </styled.div>
  )
}
